import "./assets/js/nav-pills.js";
import "./assets/scss/medical.scss";

export default {
  // eslint-disable-next-line prettier/prettier
  install() {}
};
